// -*-mode: rjsx -*-

// REACT
// eslint-disable-next-line
import React, { Component, useState } from "react"

import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { lighten, withStyles, makeStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
// import Typography from "@material-ui/core/Typography"
// import Paper from "@material-ui/core/Paper"
// eslint-disable-next-line
import Favorite from "@material-ui/icons/Favorite"
// eslint-disable-next-line
import FavoriteBorder from "@material-ui/icons/FavoriteBorder"
// eslint-disable-next-line
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
// eslint-disable-next-line
import CheckedCircle from "@material-ui/icons/CheckCircleOutline"
// eslint-disable-next-line
import Card from "@material-ui/core/Card"
// eslint-disable-next-line
import Checkbox from "@material-ui/core/Checkbox"
// import Fab from "@material-ui/core/Fab"
// import DownIcon from "@material-ui/icons/KeyboardArrowDown"
// import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
// eslint-disable-next-lines
//import grey from "@material-ui/core/colors/grey"
// MUI Table
// eslint-disable-next-line
import Table from "@material-ui/core/Table"
// eslint-disable-next-line
import TableBody from "@material-ui/core/TableBody"
// eslint-disable-next-line
import TableCell from "@material-ui/core/TableCell"
// eslint-disable-next-line
import TableHead from "@material-ui/core/TableHead"
// eslint-disable-next-line
import TablePagination from "@material-ui/core/TablePagination"
// eslint-disable-next-line
import TableRow from "@material-ui/core/TableRow"
// eslint-disable-next-line
import TableSortLabel from "@material-ui/core/TableSortLabel"
// eslint-disable-next-line
import Toolbar from "@material-ui/core/Toolbar"
// eslint-disable-next-line
import IconButton from "@material-ui/core/IconButton"
// import Tooltip from "@material-ui/core/Tooltip"
// eslint-disable-next-line
import FormControlLabel from "@material-ui/core/FormControlLabel"
// import Switch from "@material-ui/core/Switch"
// import DeleteIcon from "@material-ui/icons/Delete"
// import FilterListIcon from "@material-ui/icons/FilterList"
import Grid from '@material-ui/core/Grid';

// D3
// import * as d3 from "d3" 

// UTILS
// eslint-disable-next-line
import * as _ from "lodash"
// eslint-disable-next-line
import * as moment from "moment"

// FLASH
// eslint-disable-next-line
import DashBarChart from "../Dash/A/DashBarChart.js"
// import DashLineChart from "../Dash/A/DashLineChart.js"
// import DashMap from "../Dash/A/DashMapProto.js"
// import DashTable from "../Dash/A/DashTable.js"
// eslint-disable-next-line
import FlashTopBar from "../Flash/FlashTopBar.js"
// import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"
// import FlashBottomBar from "../Flash/FlashBottomBar.js"
// import FlashShare from "./../FlashShare.js"
// import FlashIssueChart from "../Flash/FlashIssueChart.js"
// import FlashReasonsChart from "../Flash/FlashReasonsChart.js"
// import FlashBottomPad from "../Flash/FlashBottomPad.js"
// import FlashIDashTable from "../Flash/A/FlashIDashTable.js"
// import FlashIssueCountsMap from "../Flash/A/FlashIssueCountsMap.js"
// import FlashIssueTrendsChart from "../Flash/A/FlashIssueTrendsChart.js"
// import Flash2SidesChart from "../Flash/A/Flash2SidesChart.js"
//import DashMap from "../Dash/A/DashMapV3.js"
//import DashMap from "../Dash/A/DashMapV4.js"
import DashMap from "../Dash/A/DashMapV5.js"


// BL
import { getIssuesFilters } from "../../bl/A/bl"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line

const log = appConfig.getLogger("<TestDash>")

const VARIATION = "A"

const styles = theme => ({
    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,
        flexGrow: 1,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    // maxWidth: 1500, // this is different for dashboard
            // TODO: calculate this below
            maxWidth: 1030 // it's different for sahsboard vs. webapp
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    gridContainer: {
        // backgroundColor: "yellow",
        "&.MuiGrid-spacing-xs-2": {
            // backgroundColor: "red",
            "& .MuiGrid-item": { // this one *HAS* to have a space
                // no padding for items in mobile mode
                // backgroundColor: "blue",
                [theme.breakpoints.down("sm")]: {
                    backgroundColor: "green",
                    padding: 0
                },
            }
        }
    },

    noselect: {
        "-webkit-user-select": "none",
        "-moz-user-select": "none",
        "-ms-user-select": "none",
        "-o-user-select": "none",
        "user-select": "none",
    }
})

class TestDash extends Component {
    constructor(props) {
        super(props)
        log.debug("constructor()")

        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("constructor(): localGL =", localGL)

        let oldFilters = getIssuesFilters({
            level: "Federal",
            geoState: "All-States",
            geoZip: "All-Zips"
        })

        // if(localGL && localGL.sdash && localGL.sdash.currentFilters) {
        //   oldFilters = localGL.sdash.currentFilters
        // }

        this.state = {
            gl: null,
            variation: {
                  current: VARIATION,
                  A: "/idash/a",
                  B: "/idash/b",
            },
            isTrackingOpen: false,
            redirectBack: false,
            redirectToSDash: false,
            redirectToItself: false,
            scrollerDirection: "down",
            filters: oldFilters,
            rows: [],
            highlights: [],
            geo: {
                //level: "NATIONALo",
                //level: "STATE",
                level: "USCD",
                stateCode: "CA",
                uscdCode: "14"
            },
            redraw: false
        }
    }


    parseUrl(location) {

        const search = location.search; // could be '?foo=bar'
        const params = new URLSearchParams(search);

        let geo
        try {
            geo = JSON.parse(params.get('geo'))
            if(!geo) throw new Error("Error no geo in url")
            log.debug("parseUrl(): geo =", geo)
        } catch (error) {
            log.debug("parseUrl(): ERROR: could not decode url param geo in search.params =", search)
        }
        
        return  {
            geo: geo
        }
    }

    getBarChartConfig() {
        return {
            dataset: this.getDataset(),
            col1Max: 123
        }
    }
    
    getDataset() {
        // eslint-disable-next-line
        const dataset2 = [
            {
                letter: "A",
                col1: 1000,
                col2: 2000
            },
            {
                letter: "B",
                col1: 3000,
                col2: 1500
            }
        ]
        // eslint-disable-next-line
        const dataset3 = [
            {
                letter: "A",
                col1: 1000, // bar1
                col2: 500, // bar2
                trend1: [
                    {value: 50, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 50, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 20, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 40, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 70, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            },
            {
                letter: "B",
                col1: 2000, // bar1
                col2: 600, // bar2
                trend1: [
                    {value: 60, timestamp: "2020-06-14 00:00:00.00000+00"},
                    {value: 40, timestamp: "2020-05-17 00:00:00.00000+00"},
                    {value: 60, timestamp: "2020-05-24 00:00:00.00000+00"},
                    {value: 30, timestamp: "2020-06-07 00:00:00.00000+00"}, 
                    {value: 10, timestamp: "2020-05-31 00:00:00.00000+00"}, 
                    {value: 15, timestamp: "2020-06-17 00:00:00.00000+00"}
                ]
            }
        ]

        // here we're taking an array of line/trend data
        // and enriching it with bunch of d.flash* attributes
        const enrichTrendData = (data) => {
            let prevValue
            let flashItemNumber = 1
            let flashItemDirection
            let flashItemType
            
            const enrichedData = data
	          .sort((a,b) => {
	              const am = moment(a.timestamp)
	              const bm = moment(b.timestamp)
	              return am.diff(bm)
	          })    
	          .map(d => {
	              if(flashItemNumber === 6) {
		          flashItemType = "current"
	              } else if(flashItemNumber === 5) {
		          flashItemType = "lastWeek"
	              }
	              if(prevValue) {
		          if(prevValue < d.value) {
		              flashItemDirection = "up"
		          } else if(prevValue > d.value) {
		              flashItemDirection = "down"
		          } else {
		              flashItemDirection = "same"
		          }
	              }
	              prevValue = d.value
	              return {
		          ...d,
		          flashValue: d.value,
		          flashTimestamp: moment(d.timestamp).toDate(),
		          flashItemNumber: flashItemNumber++,
		          flashItemType: flashItemType,
		          flashItemDirection: flashItemDirection
	              }
	          })
            return enrichedData
        }

        const enrichedDataset = dataset3.map(d => {
            return {
                ...d,
                trend1: enrichTrendData(d.trend1)
            }
        })

        return enrichedDataset
    }
    
    componentDidMount = () => {
        log.debug("componentDidMount()")
        window.addEventListener("scroll", this.handleScroll);
        if(this.headDivEl) this.scrollToTop()
        document.querySelector("body").style.overflowY = "scroll" // aways how scrollbar
    }

    
    componentDidUpdate = () => {
        
        // eslint-disable-next-line
        const { location, history } = this.props
        
        const {geo: parsedGeo} = this.parseUrl(location)
        log.debug("componentDidUpdate(): parsedGeo =", parsedGeo)
        
        
        if(this.state.redirectToItself === true) {
            this.setState({
                redirectToItself: false,
            })
        }

        if(JSON.stringify(this.state.geo) !== JSON.stringify(parsedGeo)) {
            this.setState({
                geo: parsedGeo,
                redirectToItself: true,
            })
        }

    }

    componentDidUpdate_old = () => {
        // eslint-disable-next-line        
        const { location, history } = this.props
        
        log.debug("componentDidUpdate()")
        // we are resetting redirecToItself
        // after forced reload in render(),
        // we can not put this code in render
        log.debug("componentDidUpdate(): this.state.geo =", this.state.geo)

        const {geo: parsedGeo} = this.parseUrl(location)
        log.debug("componentDidUpdate(): parsedGeo =", parsedGeo)
        if(parsedGeo && JSON.stringify(parsedGeo) !== JSON.stringify(this.state.geo)) {
            // we've changed url
            // history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(parsedGeo))}`)
            // history.goBack()
            this.setState({
                geo: parsedGeo,
                gotoGeo: parsedGeo,
                redirectToItself: true,
            })
            return
        }
        
        if(this.state.redirectToItself === true) {
            this.setState({
                redirectToItself: false,
                redraw: false
            })
        }
    }


    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll)
    }

    handleScroll = (event) => {
        
        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.debug("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    scrollToTop = () => {
        log.debug("scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    handleIssueChange = (issueUUID, issueTxt) => () => {
        log.debug("handleIssueChange(): issueUUID =", issueUUID)
        log.debug("handleIssueChange(): issueTxt =", issueTxt)
        log.debug("handleIssueChange(): filters =", this.state.filters)


        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("handleIssueChange(): localGL =", localGL)

        // let localGL = JSON.parse(localStorage.getItem("gl"))
        // At least at the prototype stage, we'll proabbly
        // arrive at this page directly without any registration
        // sometimes, so make sure we can do that by creating
        // gl in the fly if needed
        if(!localGL) localGL = {}
        if(!localGL.sdash) localGL.sdash = {}
        localGL.sdash.currentIssueUUID = issueUUID
        localGL.sdash.currentIssueTxt = issueTxt
        localGL.sdash.currentFilters = this.state.filters
        localStorage.setItem("gl", JSON.stringify(localGL))
        
        this.setState({redirectToSDash: true})

    }

    handleTableChange = (filters, rows) => {
        log.debug("handleTableChange(): filters =", filters)
        log.debug("handleTableChange(): rows =", rows)

        this.setState({
            ...this.state,
            filters: filters,
            rows: rows,
        })
    }

    handleRowHover = row => {
        log.debug("handleRowHover(): row =", row)
        let hightlights
        if(row.issue === "Donut") {
            hightlights = [{
                stateName: "California",
                color: "green",
            }]
        } else if(row.issue === "Cupcake") {
            hightlights = [
                {
                    stateName: "Arizona",
                    color: "red",
                },
                {
                    stateName: "New York",
                    color: "green",
                },
            ]
        }
            
        this.setState({
            ...this.state,
            highlights: hightlights
        })
    }

    handleRowUnhover = row => {
        log.debug("handleRowUnhover(): row =", row)
        const hightlights = []
        this.setState({
            ...this.state,
            highlights: hightlights
        })
    }

    toggleRedirectToItself = () => {
        this.setState((state, props) => ({
            redirectToItself: !state.redirectToItself
        }))
    }

    render() {
        const { classes, history, match, location } = this.props

        log.debug("render()")

        // redirects first
        if(this.state.redirectToSDash) {
            log.debug("render(): redirect to SDash")
            return <Redirect push to="/sdash"/>
        } else if(this.state.redirectToItself) {
            // NOTES: might work without this if we add "redraw" to the map
            //const url=`/testdash?geo=${encodeURIComponent(JSON.stringify(this.state.geo))}`
            //const url = "/sdash"
            //log.debug("render(): redirecting to itself to redraw, url = ", url)
            //log.debug("render(): redirecting to itself to redraw, state.geo = ", this.state.geo)
            //log.debug("render(): redirecting to itself to redraw, state.gotoGeo = ", this.state.gotoGeo)
            // see componentDidUpdate that resets the redirectToItself
            //history.goBack()
            // since it's to itself, don't do a push here
            const url = history.location.pathname + history.location.search
            log.debug("render(): redirecting to itself to redraw, url = ", url)

            return <Redirect to={url}/>
        }

        
        // we should be able to read link here
        // including getting an object for geo = {level: "NATIONAL"}
        // and switch betwen different views
        
        log.debug("render(): match =", match)
        log.debug("render(): location =", location)

        // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
        const search = location.search; // could be '?foo=bar'
        const params = new URLSearchParams(search);

        let urlGeo
        try {
            urlGeo = JSON.parse(params.get('geo'))
            if(!urlGeo) throw new Error("Error no geo in url")
            log.debug("render(): urlGeo =", urlGeo)
        } catch (error) {
            log.debug("render(): ERROR: could not decode url param geo in search.params =", search)
        }

        const nationalGeo = {
            level: "NATIONAL"
        }

        const stateGeo = {
            level: "STATE",
            stateCode: "CA"
        }

        const uscdGeo = {
            level: "USCD",
            stateCode: "CA",
            uscdCode: "14"
        }


        // moving to new parameters
        const geo = urlGeo ? urlGeo : this.state.geo
        const geoLevel = geo.level

        log.debug("render(): geo = ", geo)
        log.debug("render(): geoLevel = ", geoLevel)
        log.debug("render(): this.state.redirectToItself = ", this.state.redirectToItself)

	return(
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el }} ></div>

              {/*
              <FlashTopBar text="Test Issues Dashboard" variation={this.state.variation}/>
               */}
              
              <ul>
                <li><Link to={`/testdash?geo=${encodeURIComponent(JSON.stringify(nationalGeo))}`}>NATIONAL</Link></li>
                <li><Link to={`/testdash?geo=${encodeURIComponent(JSON.stringify(stateGeo))}`}>STATE</Link></li>
                <li><Link to={`/testdash?geo=${encodeURIComponent(JSON.stringify(uscdGeo))}`}>USCD</Link></li>
              </ul>

              {/*
              <button onClick={() => history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(nationalGeo))}`) } >Go NATIONAL</button>
              <button onClick={() => history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(stateGeo))}`) } >Go STATE</button>
              <button onClick={() => history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(uscdGeo))}`) } >Go USCD</button>
               */}


              <button onClick={() => {
                  history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(nationalGeo))}`)
                  this.setState({redirectToItself: true})
                  log.debug("button national")
              }}>Go NATIONAL</button>


              <button onClick={() => {
                  history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(stateGeo))}`)
                  this.setState({redirectToItself: true})
                  log.debug("button state")
              }}>Go STATE</button>

              
              <button onClick={() => {
                  history.push(`/testdash?geo=${encodeURIComponent(JSON.stringify(uscdGeo))}`)
                  this.setState({redirectToItself: true})
                  log.debug("button uscd")
              }}>Go USCD</button>

              

              <div className={classes.mainDiv}>
              
                <Grid container classes={{
                    container: classes.gridContainer
                }} spacing={2}>

                  <Grid item md={12} sm={12} classes={{}}>
                      <DashMap
                        header1={"header1"}
                        header2={"header2"}
                        // geoLevel={this.state.geo.level}
                        //geoLevel={geoLevel}
                        geo={geo}
                        redraw={this.state.redraw}
                        dataset={this.state.mapDataset}
                        highlights={this.state.mapHighlights}
                        zoomTarget={this.state.mapZoomTarget}
                        onDoubleClick={this.handleMapDoubleClick}
                        onFilterClick={this.handleMapFilterClick}
                        onPushProperties={this.handleGeoFilterMapProperties}
                      />
                  </Grid>

                  <Grid item md={12} sm={12}> 
                  </Grid>
                </Grid>
                
              </div>
              
            </React.Fragment>
        )
    }
}

TestDash.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "TestDash"})(TestDash)

